import { useContext } from "react"
import styled from "styled-components"
import MexicoTitle from '../layout/MexicoTitle'
import Image from '../layout/Image'
import { useFormik, FormikProvider } from "formik"
import * as Yup from "yup";
import { GlobalsContext } from '../../context/globals'
import Radio from "../layout/Radio"
import Buttons from "../layout/Buttons"
const Question3 = props => {
  const { state, dispatch } = useContext(GlobalsContext)
  const formik = useFormik({
    initialValues: {
      question: '',
    },
    validationSchema: Yup.object({
      question: Yup.string()
        .required('Este campo es requerido'),
    }),
    onSubmit: values => {
      dispatch(
        {
          actualQuestion: state.actualQuestion + 1,
          score: state.score + Number(values.question)
        }
      )
    },
  });
  return(<>
    <FormikProvider value={formik}>
      <Wrap>
        <QuestionWrap>
          <div>
            <MexicoTitle />
            <QuestionNumer>03</QuestionNumer>
            <QuestionTitle>
           Cuando una persona cuyo tono de piel es morena, se casa con una persona de piel de tono blanca, ¿crees que está mejorando la raza?
            </QuestionTitle>
            <QuestionsWrap>
              <Radio
                label="No"
                name="question"
                itemValue="1"/>
              <Radio
                label="Si"
                name="question"
                itemValue="3"/>   
              <Radio
                label="Puede ser"
                name="question"
                itemValue="2"/>            
            </QuestionsWrap>
          </div>
          
          <Buttons
            formik={formik} />
          
        </QuestionWrap>
        <div>
        <Image 
            url="./img/paises.png"
            title="paises" />
        </div>
      </Wrap>
    </FormikProvider>
  </>)
}
const Wrap = styled.div`
  width:100% ;
  height:100% ;
  display:grid ;
  grid-template-columns:repeat(2, 1fr) ;
  gap: 2%;
`
const QuestionWrap = styled.div`
  display:flex ;
  flex-direction: column ;
  justify-content:space-between ;
`
const QuestionNumer = styled.div`
  font-family:'Edo SZ';
  color: #2b0a01;
  font-size:4em ;
  margin-top:20px ; 
`
const QuestionTitle = styled.div`
  font-size:2em ;
  margin-top:20px ;
`
const QuestionsWrap = styled.div`
  font-size:2em ;
  margin-top:20px ;
`
export default Question3